import {MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow} from "mdbreact"
import DealerReportGrid from "../../../components/PassRateReport/PassRateSummary/PassRateReportDealer"
import RegionReportGrid from "../../../components/PassRateReport/PassRateSummary/PassRateReportRegion"
import PassRateSummaryFilter from "../../../components/PassRateReport/PassRateSummary/PassRateSummaryFilter"

const PassRateSummary = () => (
    <>
        <MDBBreadcrumb>
            <MDBBreadcrumbItem>Manage MOT</MDBBreadcrumbItem>
            <MDBBreadcrumbItem active>Pass Rates Summary</MDBBreadcrumbItem>
        </MDBBreadcrumb>
        <PassRateSummaryFilter />
        <MDBRow>
            <MDBCol xl="6" lg="6" md="12" sm="12" className="p-0 pe-2 ps-3 pb-1">
                <MDBCard>
                    <MDBCardBody className="p-2">
                        <MDBCardTitle className="text-muted">Prepared in Region Pass Rates with % of NAT</MDBCardTitle>
                        <RegionReportGrid />
                    </MDBCardBody>
                </MDBCard>
            </MDBCol>
            <MDBCol xl="6" lg="6" md="12" sm="12" className="p-0 pe-3">
                <MDBCard>
                    <MDBCardBody className="p-2">
                        <MDBCardTitle className="text-muted">Prepared by Region Pass Rates</MDBCardTitle>
                        <DealerReportGrid />
                    </MDBCardBody>
                </MDBCard>
            </MDBCol>
        </MDBRow>
    </>
)
export default PassRateSummary
